import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button } from "../../../../shared/Button/Button";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { dispatch } from "../../../../store/store";
import { providerRoom } from "../../../../store/providerRoom";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";

function TabCosmeticRowActions({ procedureId, isSentToMd, isSigning }) {
  const { tCommon } = useAppTranslation.Common();

  const handleSign = () => {
    if (!isSentToMd) {
      dispatch(
        providerRoom.actions.signProceduresDataChange({
          procedureIds: [procedureId],
          isSendToMd: true,
        }),
      );
    }
  };

  return (
    <>
      {!isSigning && (
        <Button
          size="small"
          variant={isSentToMd ? "text" : "contained"}
          isDisabled={isSentToMd || isSigning}
          onClick={handleSign}
          leftAdornment={
            isSigning ? (
              <CircularProgress size="tiny" color="white" />
            ) : undefined
          }
        >
          {isSentToMd
            ? tCommon("providerRoom.action.sentToMd")
            : tCommon("providerRoom.action.sendToMd")}
        </Button>
      )}
    </>
  );
}

TabCosmeticRowActions.propTypes = {
  procedureId: PropTypes.number.isRequired,
  isSentToMd: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired,
  isSigning: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isSigning: providerRoom.selectors.selectProcedureSigningStatus(state),
  };
}

export default connect(mapStateToProps)(TabCosmeticRowActions);
